<template>
  <v-dialog
    v-model="showModal"
    :max-width="800"
    scrollable
  >
    <v-card>
      <v-card-title>
        <div class="ft-negmy-3 ft-negml-3 pa-2">
          <v-avatar size="80px">
            <img :src="getPhoto()">
          </v-avatar>
        </div>
        <div class="pl-1">
          <v-card-text class="pa-0 title">
            {{ itemData.nameProper }}
          </v-card-text>
          <v-card-text
            v-if="itemData.memNum"
            class="pa-0 pt-1 subheading"
          >
            {{ itemData.memNum || itemData.username }} ({{ itemData.mType }} / {{ itemData.mShip }})
          </v-card-text>
          <v-card-text
            v-if="itemData.birth"
            class="pa-0 caption"
          >
            <v-icon small>
              mdi-cake-variant
            </v-icon> <span class="body-2">{{ intDateToMoment(itemData.birth).format('MMM Do YYYY') }}</span>
          </v-card-text>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <api-errors
          :errors="errors"
          class="ft-negmt-3 ft-negmx-3"
        />

        <!-- MEMBER PREFERENCES -->
        <item-editor-form
          ref="editForm"
          v-model="selectedPanel"
          :errors="errors"
          :edit-panel-id="editPanel"
          :audit-panel-id="auditPanel"
          :audit="auditHistorySettings"
        >
          <!-- START OF FORM FIELDS -->
          <v-layout wrap>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-text-field
                v-model.trim="itemData.email"
                label="Email 1"
                :error-messages="getPathErrors(jsonPath, 'email')"
                :disabled="isFormDisabled"
                :append-icon="itemData.emailOpt ? 'mdi-bell' : 'mdi-bell-off'"
                @input="clearPathErrors(jsonPath, 'email')"
                @click:append="() => itemData.emailOpt = !itemData.emailOpt"
              />
            </v-flex>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-text-field
                v-model.trim="itemData.email2"
                label="Email 2"
                :error-messages="getPathErrors(jsonPath, 'email2')"
                :disabled="isFormDisabled"
                :append-icon="itemData.emailOpt2 ? 'mdi-bell' : 'mdi-bell-off'"
                @input="clearPathErrors(jsonPath, 'email')"
                @click:append="() => itemData.emailOpt2 = !itemData.emailOpt2"
              />
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-text-field
                v-model.trim="itemData.phone1"
                label="Phone 1"
                :error-messages="getPathErrors(jsonPath, 'phone1')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'phone1')"
              />
            </v-flex>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-text-field
                v-model.trim="itemData.phone2"
                label="Phone 2"
                :error-messages="getPathErrors(jsonPath, 'phone2')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'phone1')"
              />
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex class="px-3 xs12 sm6 md6">
              <v-textarea
                v-model.trim="itemData.drinkPreference"
                label="Drink Preferences"
                :rows="1"
                auto-grow
                :error-messages="getPathErrors(jsonPath, 'drinkPreference')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'drinkPreference')"
              />
            </v-flex>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-textarea
                v-model.trim="itemData.foodPreference"
                label="Food Preferences"
                :rows="1"
                auto-grow
                :error-messages="getPathErrors(jsonPath, 'foodPreference')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'foodPreference')"
              />
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex class="px-3 xs12 sm6 md6">
              <v-textarea
                v-model.trim="itemData.allergyInformation"
                label="Allergy Information"
                :rows="1"
                auto-grow
                :error-messages="getPathErrors(jsonPath, 'allergyInformation')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'allergyInformation')"
              />
            </v-flex>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-textarea
                v-model.trim="itemData.diningSpecialRequests"
                :label="'Special Preferences' + ($ftCS.DINING_ALLOW_MEMBER_UPDATE_OF_SPECIAL_REQUESTS ? '' : ' (Hidden)')"
                :rows="1"
                auto-grow
                :error-messages="getPathErrors(jsonPath, 'diningSpecialRequests')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'diningSpecialRequests')"
              />
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex class="px-3 xs12 sm6 md6">
              <v-select
                v-model.trim="itemData.vaccinationStatus"
                label="Vaccination Status"
                item-value="id"
                :items="vaccinationStatusOptions"
                :disabled="isFormDisabled"
              />
            </v-flex>
            <v-flex class="xs12 sm6 md6 px-3">
              <v-textarea
                v-model.trim="itemData.vaccinationNotes"
                label="Vaccination Notes"
                :rows="1"
                auto-grow
                :error-messages="getPathErrors(jsonPath, 'vaccinationNotes')"
                :disabled="isFormDisabled"
                @input="clearPathErrors(jsonPath, 'vaccinationNotes')"
              />
            </v-flex>
          </v-layout>

          <!-- END OF FORM FIELDS -->
        </item-editor-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          text
          @click="hideModal"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!readOnly"
          color="primary"
          :disabled="isMemberPrefSaveDisabled"
          text
          @click="saveMemberChanges"
        >
          Save Changes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import itemEdit from '../mixins/itemEditor/itemEdit'
import {getMemberPhoto, intDateToMoment} from '../util/helpers'

var itemDefault = {
  id: null,
  nameLast: null,
  nameFirst: null,
  nameMi: null,
  namePre: null,
  nameSuf: null,
  nameFull: null,
  nameProper: null,
  memNum: null,
  email: null,
  email2: null,
  emailOpt: null,
  emailOpt2: null,
  phone1: null,
  phone2: null,
  webid: null,
  drinkPreference: null,
  foodPreference: null,
  allergyInformation: null,
  diningSpecialRequests: null,
  activePhoto: null,
  vaccinationStatus: null,
  vaccinationNotes: null
}

export default {
  name: 'MemberPreferences',
  components: {
  },
  mixins: [itemEdit],
  props: {
    value: Number
  },
  data: function () {
    return {
      type: 'Member Preferences',
      types: 'Member Preferences',
      headers: [],
      apiRecordCommand: 'memberPreferences',
      itemDefault: itemDefault,
      skipRecordLock: true,
      showModal: false,
      vaccinationStatusOptions: []
    }
  },
  computed: {
    forceReadOnly () {
      return !this.$ftAccess.manageMemberPrefs
    },
    isMemberPrefSaveDisabled () {
      return this.isSaveDisabled || !this.hasChangesToPrefs
    },
    hasChangesToPrefs () {
      const originalItem = this.originalItem
      const itemData = this.itemData
      if (!originalItem) return false
      for (let key in itemDefault) {
        if (originalItem[key] !== itemData[key] && !(originalItem[key] === undefined && itemData[key] === null)) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    value () {
      if (this.value !== this.selectedItemId) {
        this.selectedItemId = this.value
      }
      this.setModal()
    },
    selectedItemId (val) {
      if (val !== this.value) {
        this.$emit('input', val)
      }
    },
    showModal (val) {
      if (!val) this.selectedItemId = undefined
    }
  },
  methods: {
    intDateToMoment: intDateToMoment,
    beforeLoadData () {
      this.showModal = !!this.selectedItemId
      return this.showModal
    },
    getItemDataChanges () {
      var foundChanges = false
      const changes = {}
      const originalItem = this.originalItem
      const itemData = this.itemData
      if (!originalItem) return false
      for (let key in itemDefault) {
        if (originalItem[key] !== itemData[key] && !(originalItem[key] === undefined && itemData[key] === null)) {
          changes[key] = itemData[key]
          foundChanges = true
        }
      }
      if (!foundChanges) return null
      changes.id = itemData.id
      return changes
    },
    backToCaller () {
      this.$emit('change', this.itemData)
      this.hideModal()
    },
    saveMemberChanges () {
      this.saveItem()
    },
    getPhoto () {
      return getMemberPhoto(this.itemData.activePhoto, this.itemData.gender)
    },
    loadList () {
      // Normally loads item list.  Do nothing for memberPreferences modal.
    },
    hideModal () {
      this.showModal = false
      this.selectedItemId = undefined
    },
    openModal () {
      this.showModal = true
    },
    setModal () {
      this.showModal = !!this.selectedItemId
    },
    itemResourceCommands () {
      return [
        {
          command: 'apiFieldOption',
          load: this.vaccinationStatusOptions,
          loading: this.isLoading,
          params: {filter_methods: {forField: ['member', 'vaccinationStatus']}}
        }
      ]
    }
  }
}
</script>
